import service from "../services/marcas.service";

export const marcas = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    async getMarcas() {
      try {
        return await service.getMarcas();
      } catch (error) {
        console.error("Error fetching marcas:", error);
        throw error.response;
      }
    },
    async save(_context, data) {
      try {
        if (data.id === 0) {
          return await service.createData(data);
        }
        return await service.updateData(data.id, data);
      } catch (error) {
        console.error("Error saving marca:", error);
        throw error.response;
      }
    },
    async delete(_context, id) {
      try {
        return await service.deleteData(id);
      } catch (error) {
        throw error.response;
      }
    },
  },
  mutations: {},
};
